import {
  ClientWorkFlowStatus,
  InvoiceStatus
} from "@wingspanhq/payments/dist/interfaces";
import {
  PayablesFilter,
  PayablesListRequestQuery
} from "../../../services/payments";

const baseFilter: PayablesFilter = {
  "labels.invoiceType": {
    "!=": "approvedInvoicesPayment"
  },
  "labels.creationSource": {
    "!=": "personalPaylink"
  }
};

export const API_QUERY_PAYABLES_TO_APPROVE: PayablesListRequestQuery = {
  filter: {
    ...baseFilter,
    status: {
      in: [InvoiceStatus.Open, InvoiceStatus.Overdue, InvoiceStatus.Pending]
    },
    "client.workflowStatus": {
      notIn: [
        ClientWorkFlowStatus.Approved,
        ClientWorkFlowStatus.PaymentInitiated,
        ClientWorkFlowStatus.Funded
      ]
    }
  },
  excludeDeclined: "true"
};

export const API_QUERY_PAYABLES_DUAL_STAGE_TO_PREAPPROVE: PayablesListRequestQuery =
  {
    filter: {
      ...baseFilter,
      status: {
        in: [InvoiceStatus.Open, InvoiceStatus.Overdue, InvoiceStatus.Pending]
      },
      "client.workflowStatus": {
        notIn: [
          ClientWorkFlowStatus.PreApproved,
          ClientWorkFlowStatus.Approved,
          ClientWorkFlowStatus.PaymentInitiated,
          ClientWorkFlowStatus.Funded
        ]
      }
    },
    excludeDeclined: "true"
  };

export const API_QUERY_PAYABLES_DUAL_STAGE_TO_APPROVE: PayablesListRequestQuery =
  {
    filter: {
      ...baseFilter,
      status: {
        in: [InvoiceStatus.Open, InvoiceStatus.Overdue, InvoiceStatus.Pending]
      },
      "client.workflowStatus": ClientWorkFlowStatus.PreApproved
    },
    excludeDeclined: "true"
  };

export const API_QUERY_PAYABLES_OPEN: PayablesListRequestQuery = {
  filter: {
    ...baseFilter,
    status: InvoiceStatus.Open
  },
  excludeDeclined: "true"
};

export const API_QUERY_PAYABLES_OVERDUE: PayablesListRequestQuery = {
  filter: {
    ...baseFilter,
    status: InvoiceStatus.Overdue
  },
  excludeDeclined: "true"
};

export const API_QUERY_PAYABLES_DRAFT: PayablesListRequestQuery = {
  filter: {
    ...baseFilter,
    status: InvoiceStatus.Draft
  }
};
